import React, {Component} from 'react';
import PropTypes from 'prop-types';
import css from './popup.scss';

class Popup extends Component {
	state = {
		visible: false,
	};
	static propTypes = {
		opened: PropTypes.bool,
		onConfirm: PropTypes.func,
	};
	open = _ => {
		this.setState(_ => ({visible: true}));
	};
	close = _ => {
		this.setState(_ => ({visible: false}));
	};
	componentDidMount() {
		if (this.props.opened) {
			this.open();
		}
	}
	render() {
		let visible = this.state.visible ? '' : ' hidden';
		return (
			<div className={css.wrapper + visible}>
				<div className={css.cache} onClick={this.close} />
				<div className={css.popup}>
					<p children={this.props.children} />
					{this.props.onConfirm ? (
						[
							<button
								key="cancel"
								type="button"
								className={css.cancel}
								onClick={this.close}
							>
								Annuler
							</button>,
							<button
								key="confirm"
								type="button"
								className={css.confirm}
								onClick={_ => {
									this.props.onConfirm();
									this.close();
								}}
							>
								Supprimer
							</button>,
						]
					) : (
						<button
							type="button"
							className={css.cancel}
							onClick={this.close}
						>
							Ok
						</button>
					)}
				</div>
			</div>
		);
	}
}

export default Popup;



// WEBPACK FOOTER //
// ./src/components/popup/popup.js